module.exports = __webpack_public_path__ + "img/client.54631100.svg";